/* eslint-disable */
export default {
  forward: 'Inoltra',
  ignore: 'Ignora',
  toVoicemail: 'Alla segreteria telefonica',
  answer: 'Rispondi',
  endAndAnswer: 'Chiudi e rispondi',
  holdAndAnswer: 'Metti in attesa e rispondi',
  custom: 'Personalizzato',
  more: 'Altro',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
